export default __webpack_public_path__ + "media/images/fb_ico-a72575fbdac192ef7332d463eae28069.png";